import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ITabelaPreco } from '../../model';

@Injectable()
export class TabelaPrecoService extends EntityService<ITabelaPreco> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'tabela_preco',
      urlBackend: configService.backendURL
    });
  }
}
